import { render, staticRenderFns } from "./FreeVip.vue?vue&type=template&id=46d89f3a&scoped=true&"
import script from "./FreeVip.vue?vue&type=script&lang=js&"
export * from "./FreeVip.vue?vue&type=script&lang=js&"
import style0 from "./FreeVip.vue?vue&type=style&index=0&id=46d89f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d89f3a",
  null
  
)

export default component.exports